namespace $.$$ {

	export class $shm_markdown_text_list extends $.$shm_markdown_text_list {

		override rows() {
			return super.rows().map( ( row, index )=> this.flow_tokens()[ index ].name === 'code-indent'
				? this.Continuation( index )
				: row,
			)
		}

	}

}
